import { Platform, StyleSheet } from 'react-native';
import { neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  focusRing: {
    ...Platform.select({
      web: {
        // box-shadow is not suppressed by the global :focus-visible { outline: none } in index.html
        boxShadow: '0 0 0 2px #FFFFFF, 0 0 0 4px #105DC1',
      },
    }),
  },
  hoverTextContainer: {
    position: 'absolute',
    bottom: 30, // Posizionato sopra l'icona
    backgroundColor: neutrals.white,
    zIndex: 100,
    borderRadius: 8,
    justifyContent: 'center',
    paddingHorizontal: 12,
    paddingVertical: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    alignItems: 'center',
  },
  hoverText: {
    color: neutrals.black,
    fontSize: 12,
    lineHeight: 15.6, //12* 130%
    fontWeight: '700',
    ...Platform.select({
      web: {
        whiteSpace: 'nowrap' as any,
      },
    }),
  },
});
